module.exports = __webpack_public_path__ + "static/img/hypnose-01.0a2bb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-01.png
// module id = 95
// module chunks = 0